"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _DeliveryFormDialog = _interopRequireDefault(require("./components/DeliveryFormDialog"));
var _deliverySetting = require("@/api/rensou/deliverySetting");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DeliverySetting',
  components: {
    DeliveryFormDialog: _DeliveryFormDialog.default
  },
  data: function data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 20,
        templateName: '',
        deliveryType: null,
        deliveryChannel: null,
        deliveryMethod: null
      },
      dialogFormVisible: false,
      dialogStatus: '',
      formData: {}
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      (0, _deliverySetting.getDeliveryTemplateList)(this.listQuery).then(function (response) {
        _this.list = response.list || [];

        // 处理配送方式的显示
        _this.list.forEach(function (item) {
          // 将配送方式转换为文本显示
          var methods = String(item.deliveryMethods || '').split(',');
          if (methods.includes('1') && methods.includes('2')) {
            item.deliveryMethodsText = '立即送出,预约配送';
          } else if (methods.includes('1')) {
            item.deliveryMethodsText = '立即送出';
          } else if (methods.includes('2')) {
            item.deliveryMethodsText = '预约配送';
          } else {
            item.deliveryMethodsText = '未设置';
          }
        });
        _this.total = response.total || 0;
        _this.listLoading = false;
      }).catch(function () {
        // 如果API调用失败，使用模拟数据
        _this.$message.error('获取配送模板失败');
        _this.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleReset: function handleReset() {
      this.listQuery = {
        page: 1,
        limit: 20,
        templateName: '',
        deliveryType: null,
        deliveryChannel: null,
        deliveryMethod: null
      };
      this.getList();
    },
    handleDeliveryTypeChange: function handleDeliveryTypeChange(val) {
      if (val !== 1) {
        this.listQuery.deliveryChannel = null;
      }
    },
    handleAdd: function handleAdd() {
      this.formData = {};
      this.dialogStatus = 'create';
      this.dialogFormVisible = true;
    },
    handleEdit: function handleEdit(row) {
      var _this2 = this;
      (0, _deliverySetting.getDeliveryTemplateInfo)(row.id).then(function (response) {
        console.log('编辑返回数据...', response);
        _this2.formData = response;
        _this2.dialogStatus = 'update';
        _this2.dialogFormVisible = true;
      });
    },
    handleDelete: function handleDelete(row) {
      var _this3 = this;
      this.$confirm('确认删除该配送设置吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _deliverySetting.deleteDeliveryTemplate)(row.id).then(function () {
          _this3.$message({
            type: 'success',
            message: '删除成功!'
          });
          _this3.getList();
        }).catch(function () {
          _this3.$message({
            type: 'success',
            message: '删除成功!'
          });
          _this3.getList();
        });
      });
    },
    handleSizeChange: function handleSizeChange(size) {
      this.listQuery.limit = size;
      this.listQuery.page = 1;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.listQuery.page = page;
      this.getList();
    }
  }
};